import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Megaphone } from "@phosphor-icons/react";

export default function CommunityFeed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/portal/community").then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="community-feed-page">
      <h1 className="font-heading text-3xl text-white tracking-tight mb-6">Community Board</h1>
      <div className="space-y-4">
        {posts.map((p) => (
          <div key={p.id} data-testid={`community-post-${p.id}`} className="bg-[#141414] border border-[#27272A] rounded-2xl p-6">
            <div className="flex items-center gap-2 mb-2">
              <Megaphone size={16} className="text-[#D4AF37]" />
              <span className="text-xs uppercase tracking-wide text-[#D4AF37]">{p.category}</span>
            </div>
            <h3 className="font-heading text-xl text-white tracking-tight mb-1">{p.title}</h3>
            <p className="text-sm text-[#A1A1AA] mb-2 leading-relaxed">{p.content}</p>
            <p className="text-xs text-[#71717A]">
              {p.author} &middot; {new Date(p.created_at).toLocaleDateString()}
            </p>
          </div>
        ))}
        {!posts.length && <p className="text-[#71717A]">No posts yet. Check back soon!</p>}
      </div>
    </div>
  );
}
